

export function MobileAppIllustration() {
  return (
    <svg viewBox="0 0 600 260" xmlns="http://www.w3.org/2000/svg" fill="none" width="100%" height="100%" className="max-h-full max-w-full text-current">
      {/* Tablet */}
      <g transform="rotate(-7 158 125)">
        <rect x="58" y="55" width="200" height="140" rx="20" stroke="currentColor" strokeWidth="2.5" strokeOpacity="0.3"/>
        <line x1="80" y1="95" x2="190" y2="95" stroke="currentColor" strokeWidth="2" strokeOpacity="0.25" strokeLinecap="round"/>
        <line x1="80" y1="115" x2="160" y2="115" stroke="currentColor" strokeWidth="2" strokeOpacity="0.25" strokeLinecap="round"/>
        <line x1="80" y1="135" x2="200" y2="135" stroke="currentColor" strokeWidth="2" strokeOpacity="0.25" strokeLinecap="round"/>
      </g>
      {/* Phone */}
      <g transform="rotate(4 395 130)">
        <rect x="330" y="18" width="130" height="224" rx="26" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="3" strokeOpacity="0.95"/>
        <rect x="375" y="32" width="40" height="6" rx="3" fill="currentColor" fillOpacity="0.8"/>
        <rect x="346" y="64" width="98" height="30" rx="8" stroke="currentColor" strokeWidth="2" strokeOpacity="0.85"/>
        <rect x="346" y="104" width="98" height="30" rx="8" stroke="currentColor" strokeWidth="2" strokeOpacity="0.85"/>
        <rect x="346" y="150" width="22" height="22" rx="6" stroke="currentColor" strokeWidth="2" strokeOpacity="0.75"/>
        <rect x="376" y="150" width="22" height="22" rx="6" stroke="currentColor" strokeWidth="2" strokeOpacity="0.75"/>
        <rect x="406" y="150" width="22" height="22" rx="6" stroke="currentColor" strokeWidth="2" strokeOpacity="0.75"/>
        <rect x="375" y="218" width="40" height="4" rx="2" fill="currentColor" fillOpacity="0.6"/>
      </g>
      {/* Tap ripple */}
      <circle cx="478" cy="208" r="15" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.35"/>
      <circle cx="478" cy="208" r="8" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.5"/>
      <circle cx="478" cy="208" r="3.5" fill="currentColor" fillOpacity="0.95"/>
    </svg>
  )
}

export function WebIllustration() {
  return (
    <svg viewBox="0 0 320 220" xmlns="http://www.w3.org/2000/svg" fill="none" width="100%" height="100%" className="max-h-full max-w-full text-current">
      {/* Phone */}
      <g transform="rotate(-8 55 95)">
        <rect x="20" y="40" width="70" height="110" rx="16" stroke="currentColor" strokeWidth="2" strokeOpacity="0.35"/>
        <line x1="32" y1="70" x2="78" y2="70" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.25" strokeLinecap="round"/>
        <line x1="32" y1="86" x2="64" y2="86" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.25" strokeLinecap="round"/>
      </g>
      {/* Browser */}
      <rect x="120" y="25" width="180" height="130" rx="14" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="3" strokeOpacity="0.95"/>
      <line x1="120" y1="48" x2="300" y2="48" stroke="currentColor" strokeWidth="2" strokeOpacity="0.85"/>
      <circle cx="129" cy="36.5" r="1.8" fill="currentColor" fillOpacity="0.7"/>
      <circle cx="136" cy="36.5" r="1.8" fill="currentColor" fillOpacity="0.7"/>
      <circle cx="143" cy="36.5" r="1.8" fill="currentColor" fillOpacity="0.7"/>
      <rect x="132" y="58" width="156" height="14" rx="6" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.85"/>
      <rect x="132" y="80" width="42" height="58" rx="6" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.85"/>
      <rect x="182" y="80" width="106" height="26" rx="6" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.85"/>
      <rect x="182" y="112" width="106" height="26" rx="6" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.85"/>
      {/* Signature accent */}
      <circle cx="296" cy="166" r="9" stroke="currentColor" strokeWidth="1.4" strokeOpacity="0.35"/>
      <circle cx="296" cy="166" r="5" stroke="currentColor" strokeWidth="1.4" strokeOpacity="0.5"/>
      <circle cx="296" cy="166" r="2.2" fill="currentColor" fillOpacity="0.95"/>
    </svg>
  )
}

export function ApiIllustration() {
  return (
    <svg viewBox="0 0 320 220" xmlns="http://www.w3.org/2000/svg" fill="none" width="100%" height="100%" className="max-h-full max-w-full text-current">
      {/* Client */}
      <g transform="rotate(-6 65 90)">
        <rect x="25" y="55" width="80" height="70" rx="12" stroke="currentColor" strokeWidth="2" strokeOpacity="0.35"/>
        <line x1="40" y1="78" x2="90" y2="78" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.25" strokeLinecap="round"/>
        <line x1="40" y1="93" x2="78" y2="93" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.25" strokeLinecap="round"/>
      </g>
      {/* Request flow */}
      <path d="M106 90 C 128 90 132 95 158 95" stroke="currentColor" strokeWidth="2" strokeOpacity="0.75" strokeDasharray="4 5" strokeLinecap="round"/>
      <path d="M152 90 L160 95 L152 100" stroke="currentColor" strokeWidth="2" strokeOpacity="0.75" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Endpoint card */}
      <rect x="160" y="20" width="135" height="160" rx="16" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="3" strokeOpacity="0.95"/>
      <rect x="174" y="34" width="42" height="9" rx="4.5" fill="currentColor" fillOpacity="0.8"/>
      <rect x="174" y="56" width="24" height="7" rx="3.5" fill="currentColor" fillOpacity="0.85"/>
      <rect x="204" y="56" width="58" height="7" rx="3.5" fill="currentColor" fillOpacity="0.65"/>
      <rect x="174" y="78" width="20" height="7" rx="3.5" fill="currentColor" fillOpacity="0.85"/>
      <rect x="200" y="78" width="66" height="7" rx="3.5" fill="currentColor" fillOpacity="0.65"/>
      <rect x="174" y="100" width="28" height="7" rx="3.5" fill="currentColor" fillOpacity="0.85"/>
      <rect x="208" y="100" width="50" height="7" rx="3.5" fill="currentColor" fillOpacity="0.65"/>
      {/* Status chip with signature accent */}
      <rect x="174" y="148" width="58" height="24" rx="12" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.85"/>
      <circle cx="194" cy="160" r="9" stroke="currentColor" strokeWidth="1.4" strokeOpacity="0.35"/>
      <circle cx="194" cy="160" r="5" stroke="currentColor" strokeWidth="1.4" strokeOpacity="0.5"/>
      <circle cx="194" cy="160" r="2.2" fill="currentColor" fillOpacity="0.95"/>
      <rect x="208" y="156" width="14" height="7" rx="3.5" fill="currentColor" fillOpacity="0.8"/>
    </svg>
  )
}

export function BackendIllustration() {
  return (
    <svg viewBox="0 0 320 220" xmlns="http://www.w3.org/2000/svg" fill="none" width="100%" height="100%" className="max-h-full max-w-full text-current">
      {/* Node cluster */}
      <g strokeOpacity="0.35">
        <line x1="40" y1="70" x2="70" y2="45" stroke="currentColor" strokeWidth="1.4"/>
        <line x1="70" y1="45" x2="78" y2="95" stroke="currentColor" strokeWidth="1.4"/>
        <line x1="40" y1="70" x2="78" y2="95" stroke="currentColor" strokeWidth="1.4"/>
      </g>
      <circle cx="40" cy="70" r="9" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.45"/>
      <circle cx="70" cy="45" r="9" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.45"/>
      <circle cx="78" cy="95" r="9" stroke="currentColor" strokeWidth="1.8" strokeOpacity="0.45"/>
      <path d="M87 95 C 110 100 128 104 150 109" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.35" strokeDasharray="4 5"/>
      {/* Server stack */}
      <rect x="150" y="20" width="150" height="30" rx="11" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="2.8" strokeOpacity="0.95"/>
      <rect x="150" y="57" width="150" height="30" rx="11" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="2.8" strokeOpacity="0.95"/>
      <rect x="150" y="94" width="150" height="30" rx="11" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="2.8" strokeOpacity="0.95"/>
      <rect x="150" y="131" width="150" height="30" rx="11" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="2.8" strokeOpacity="0.95"/>
      <line x1="164" y1="35" x2="178" y2="35" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.85" strokeLinecap="round"/>
      <line x1="164" y1="72" x2="178" y2="72" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.85" strokeLinecap="round"/>
      <line x1="164" y1="109" x2="178" y2="109" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.85" strokeLinecap="round"/>
      <line x1="164" y1="146" x2="178" y2="146" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.85" strokeLinecap="round"/>
      <line x1="286" y1="29" x2="286" y2="41" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.75" strokeLinecap="round"/>
      <line x1="286" y1="66" x2="286" y2="78" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.75" strokeLinecap="round"/>
      <line x1="286" y1="103" x2="286" y2="115" stroke="currentColor" strokeWidth="1.6" strokeOpacity="0.75" strokeLinecap="round"/>
      {/* Signature active layer */}
      <circle cx="270" cy="146" r="9" stroke="currentColor" strokeWidth="1.4" strokeOpacity="0.35"/>
      <circle cx="270" cy="146" r="5" stroke="currentColor" strokeWidth="1.4" strokeOpacity="0.5"/>
      <circle cx="270" cy="146" r="2.2" fill="currentColor" fillOpacity="0.95"/>
    </svg>
  )
}
